module.exports = __webpack_public_path__ + "static/media/diagnostic_rule-01.0b5bb996.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/diagnostic_rule-01.png
// module id = 517
// module chunks = 0